<template>
    <div class="root_page_center root_home">
        <div class="wrapper_home">
            <div class="session1">
                <div class="imgUserHome">
                    <img src="../assets/images/account.png" @click="showmodal=true" alt="" v-if="listInfo.portrait == null">
                    <img :src="linkWebAdmin + listInfo.portrait" @click="showmodal=true" alt="" v-else>
                </div>
                <div class="infoHome" style="color: #000;">
                    <p>Mã số thuế: <span>{{ listInfo.tax_code }}</span></p>
                    <p v-if="listInfo.company_name == null">Công ty: <span>đang nhập dữ liệu</span></p>
                    <p v-else>Công ty: <span>{{ listInfo.company_name }}</span></p>
                    <p v-if="listInfo.name != null">Người đại diện: <span>{{ listInfo.name }}</span></p>
                </div>
            </div>
            <div class="session2">
                <div class="row">
                    <!-- <div class="col-md-3 col-sm-3 col-xs-3 wp_itemCnHome">
                        <div class="itemCnHome">
                            <router-link to="/setting">
                                <img src="../assets/images/icon/1.png" alt="">
                                <p>Cập nhật công ty</p>
                            </router-link>
                        </div>
                    </div> -->
                    <div class="col-md-4 col-sm-4 col-xs-4 wp_itemCnHome">
                        <div class="itemCnHome">
                            <router-link to="/register-online">
                                <img src="../assets/images/icon/2.png" alt="">
                                <p>Đăng ký trực tuyến</p>
                            </router-link>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-4 col-xs-4 wp_itemCnHome">
                        <div class="itemCnHome">
                            <router-link to="/identifier">
                                <img src="../assets/images/icon/18.png" alt="">
                                <p>Định danh</p>
                            </router-link>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-4 col-xs-4 wp_itemCnHome">
                        <div class="itemCnHome">
                            <router-link to="/link-account">
                                <img src="../assets/images/icon/3.png" alt="">
                                <p>Liên kết tài khoản</p>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="session3">
                <h4>Danh sách nhóm dịch vụ <span>Xem tất cả <img src="../assets/images/right.png" alt=""></span></h4>
                <div class="row">
                    <div class="col-md-4 col-sm-4 col-xs-4 wp_itemCnHome" v-for="(item, index) in listData" :key="index">
                        <div class="itemCnHome itemCnHomes">
                            <router-link to="/loading">
                                <img :src="item.image" alt="">
                                <p>{{ item.name }}</p>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="img_nt_btn">
                <!-- <img src="../assets/images/btn.png" alt=""> -->
                <div class="img_nt_btn_lf">
                    <h2>Nộp thuế điện tử</h2>
                    <p>Nhanh chóng - an toàn - mọi lúc, mọi nơi</p>
                </div>
                <div class="img_nt_btn_rg">
                    <p>Nộp ngay <img src="../assets/images/right.png" alt=""></p>
                </div>
            </div>
            <!-- modal change password -->
            <div class="modalRedirect" v-if="showmodal">
                <div class="content_modalredirect">
                    <p @click="showmodal = false" class="closeMdredirect"><img src="../assets/images/close.png" @click="showmodal = false" alt=""></p>
                    <h3 class="textBalance">Đổi mật khẩu</h3>
                    <form action="" method="post" @submit="changePassword($event)">
                        <div class="inputUpdate">
                            <input :type="showPassword.current ? 'text' : 'password'" placeholder="Mật khẩu cũ" v-model="current_password">
                            <img src="../assets/images/eye1.png" @click="togglePassword('current')" alt="" class="iconpassword icon_hide" v-if="showPassword.current">
                            <img src="../assets/images/eye2.png" @click="togglePassword('current')" alt="" class="iconpassword icon_show" v-else>
                        </div>
                        <div class="inputUpdate">
                            <input :type="showPassword.new ? 'text' : 'password'" placeholder="Mật khẩu mới" v-model="new_password">
                            <img src="../assets/images/eye1.png" @click="togglePassword('new')" alt="" class="iconpassword icon_hide" v-if="showPassword.new">
                            <img src="../assets/images/eye2.png" @click="togglePassword('new')" alt="" class="iconpassword icon_show" v-else>
                        </div>
                        <div class="inputUpdate">
                            <input :type="showPassword.confirm ? 'text' : 'password'" placeholder="Xác nhận mật khẩu" v-model="new_password_confirmation">
                            <img src="../assets/images/eye1.png" @click="togglePassword('confirm')" alt="" class="iconpassword icon_hide" v-if="showPassword.confirm">
                            <img src="../assets/images/eye2.png" @click="togglePassword('confirm')" alt="" class="iconpassword icon_show" v-else>
                        </div>
                        <div class="inputUpdate">
                            <button>Cập nhật</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import SocketIO from 'socket.io-client'
export default {
    name: 'Home_tool',
    data () {
        return {
            token: window.localStorage.getItem('token'),
            listData: [],
            listInfo: [],
            showmodal: false,
            current_password: '',
            new_password: '',
            new_password_confirmation: '',
            showPassword: {
                current: false,
                new: false,
                confirm: false
            },
            linkpdf: '',
            socket: null
        }
    },
    components: {
        
    },
    mounted () {
        
    },
    created () {
        this.getListData()
        this.getDataListInfo()
        this.getListPdf()
        this.socketEventPdf()
    },
    computed: {
        
    },
    beforeUnmount() {
        if (this.socket) {
            this.socket.disconnect()
        }
    },
    methods: {
        getListData () {
            this.listData = [
                { image: require('@/assets/images/icon/6.png'), link: '/', name: 'Đăng ký thuế'},
                { image: require('@/assets/images/icon/7.png'), link: '/', name: 'Hỗ trợ quyết toán thuế TNCN'},
                { image: require('@/assets/images/icon/8.png'), link: '/', name: 'Tra cứu hồ sơ khai thuế'},
                { image: require('@/assets/images/icon/9.png'), link: '/', name: 'Nhóm chức năng nộp thuế'},
                { image: require('@/assets/images/icon/10.png'), link: '/', name: 'Tra cứu thông tin thuế'},
                { image: require('@/assets/images/icon/11.png'), link: '/', name: 'Tra cứu thông báo'},
                { image: require('@/assets/images/icon/12.png'), link: '/', name: 'Tiện ích'},
                { image: require('@/assets/images/icon/13.png'), link: '/', name: 'Hỗ trợ'},
                { image: require('@/assets/images/icon/14.png'), link: '/', name: 'Thiết lập cá nhân'},
                { image: require('@/assets/images/icon/15.png'), link: '/', name: 'Đổi mật khẩu'},
                { image: require('@/assets/images/icon/16.png'), link: '/', name: 'Đăng nhập bằng vân tay'},
                { image: require('@/assets/images/icon/17.png'), link: '/', name: 'Khám phá'},
                { image: require('@/assets/images/icon/18.png'), link: '/', name: 'Định danh'},
                { image: require('@/assets/images/icon/19.png'), link: '/', name: 'Giấy tờ'},
                { image: require('@/assets/images/icon/20.png'), link: '/', name: 'Tích hợp thông tin'},
                { image: require('@/assets/images/icon/21.png'), link: '/', name: 'Người kê khai'},
                { image: require('@/assets/images/icon/22.png'), link: '/', name: 'Cá nhân'},
                { image: require('@/assets/images/icon/23.png'), link: '/', name: 'Bảo hiểm xã hội'}
            ]
        },
        logout() {
            $('#loadingImg').show().fadeIn(10)
            this.axios.post(this.api_Logout,
                {

                },
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                $('#loadingImg').css('display', 'none')
                localStorage.removeItem('token');
                localStorage.removeItem('idUser');
                this.$swal({
                    position: 'top-end',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                })
                setTimeout(() => {
                    window.location.href = '/'
                }, 2000);
            }).catch(e => {
                $('#loadingImg').css('display', 'none')
                if (e.response.status == 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('idUser');
                    this.$swal({
                        position: 'top-end',
                        icon: 'success',
                        title: 'Đăng xuất thành công',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 2000);
                }
            })
        },
        getDataListInfo () {
            this.axios.get(this.api_userInfo,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.listInfo = response.data.data
            }).catch(e => {
                if(e.response.status == 401){
                    localStorage.removeItem('token');
                    localStorage.removeItem('idUser');
                    this.$swal({
                        position: 'top-end',
                        icon: 'error',
                        title: 'Kết thúc phiên đăng nhập',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 2000);
                }
            })
        },
        togglePassword(field) {
            this.showPassword[field] = !this.showPassword[field];
        },
        changePassword (e) {
            e.preventDefault()
            $('#loadingImg').show().fadeIn(10)
            this.axios.post(this.api_changePass, 
                {
                    current_password: this.current_password,
                    new_password: this.new_password,
                    new_password_confirmation: this.new_password_confirmation,
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                $('#loadingImg').css('display', 'none')
                this.showmodal = this.showPassword = false
                this.current_password = this.new_password = this.new_password_confirmation = ''
                this.$swal({
                    position: 'top-end',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                })
            }).catch(e => {
                $('#loadingImg').css('display', 'none')
                this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: e.response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                })
            })
        },
        getListPdf() {
            this.axios.get(this.api_pdf,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.linkpdf = response.data.data.link_pdf
            })
        },
        socketEventPdf () {
            let thiss = this
            var idUser = window.localStorage.getItem('idUser')
            this.socket = SocketIO(this.linkWebAdmin, { transports: ['websocket', 'polling', 'flashsocket'], reconnection: true, reconnectionAttempts: 5, reconnectionDelay: 2000 });
            this.socket.on(`laravel_database_private-user.${idUser}:Pdf`, function(result) {
                thiss.linkpdf = result.pdf.link_pdf
            });
        },
    }
}
</script>
<style>
    .inputUpdate{
        position: relative;
    }
</style>
